import React, {memo} from 'react'

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import Button from '@mui/material/Button';

import clsx from 'clsx';
import useStyles from '../styles/Styles'

const Paginator = ({itemsLabel, noneFound, noneFoundMessage, setSettingsOpen, itemsLength, isSmd, isMd, isMdl, page, pages, perPage, setPage, settingsLabel }) => {
	const classes = useStyles();

	return (
		<Paper className={clsx(classes.innerContent, classes.paginator)} square={true} >
			{noneFound ? 
			<Grid container spacing={isMdl ? 2 : 1}  
				alignItems="center"
				justifyContent={isMdl ? 'space-between' : 'center'} 
				direction={isMdl ? 'row' : 'column'}
			>
			<Grid item >
			<Typography variant="body1">
			{noneFoundMessage}
			</Typography>
			</Grid>
			<Grid item >
			<Button 
				color="primary"
				sx={{
					marginRight: {
						xs: '-3px',
						smd: '-8px',
					}
				}}
				onClick={() => {setSettingsOpen(true)}}
			>Settings</Button>
			</Grid>
			</Grid> :
			<Grid container spacing={isSmd ? 2 : 1} 
				alignItems="center"
				justifyContent={isSmd ? 'space-between' : 'center'} 
				direction={isSmd ? 'row' : 'column'}
			>
			<Grid item >
			<Typography variant="body1">
				{itemsLabel}: {itemsLength === 0 ? 0 : (page - 1) * perPage + 1}-{page < pages ? page * perPage : itemsLength} of {itemsLength}
			</Typography>
			</Grid>
			<Grid item >
			<Grid container>
			<Button color="primary"
			onClick={() => {setSettingsOpen(true)}}
			>{settingsLabel || 'Settings'}</Button>
			<div className={classes.settingsDivider}></div>
			<IconButton aria-label="first page" color="primary" disabled={page < 2} size={isMd ? 'medium' : 'small'}
				onClick={() => setPage(1)}
			>
			  <FirstPageIcon />
			</IconButton>
			<IconButton aria-label="previous page" color="primary" disabled={page < 2} size={isMd ? 'medium' : 'small'}
				onClick={() => setPage(page - 1)}
			>
			  <NavigateBeforeIcon />
			</IconButton>
			<IconButton aria-label="next page" color="primary" disabled={page === pages} size={isMd ? 'medium' : 'small'}
				onClick={() => setPage(page + 1)}
			>
			  <NavigateNextIcon />
			</IconButton>
			<IconButton aria-label="last page" color="primary" disabled={page === pages} 
				size={isMd ? 'medium' : 'small'} 
				edge='end'
				onClick={() => setPage(pages)}
			>
			  <LastPageIcon />
			</IconButton>

			</Grid>
			</Grid>
			</Grid>
			
			}
		
		</Paper>
)};

export default memo(Paginator)